import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

interface Props {
    label: string;
    overrideLabel: string;
    inheritedFromLabel: string;
    overrideChecked: boolean;
    onToggleOverride: (checked: boolean) => void;
    value: string;
    onChangeValue: (value: string) => void;
    inheritValue: string | number;
    errorKey?: string;
    helperText?: string;
    inputProps?: React.ComponentProps<typeof TextField>['inputProps'];
}

export function SlaField({
    label,
    overrideLabel,
    inheritedFromLabel,
    overrideChecked,
    onToggleOverride,
    value,
    onChangeValue,
    inheritValue,
    errorKey,
    helperText,
    inputProps
}: Props) {
    return (
        <Box data-testid="sla-field">
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0.5 }}>
                <Typography variant="body2" fontWeight={500}>
                    {label}
                </Typography>
                <FormControlLabel
                    control={<Switch size="small" checked={overrideChecked} onChange={(e) => onToggleOverride(e.target.checked)} />}
                    label={overrideLabel}
                    labelPlacement="end"
                    sx={{ '& .MuiFormControlLabel-label': { fontSize: 12, color: 'text.secondary' } }}
                />
            </Stack>
            {overrideChecked ? (
                <TextField
                    type="number"
                    value={value}
                    onChange={(e) => onChangeValue(e.target.value)}
                    size="small"
                    fullWidth
                    error={!!errorKey}
                    helperText={errorKey || helperText}
                    inputProps={inputProps ?? { min: 0 }}
                />
            ) : (
                <Box
                    sx={{
                        bgcolor: 'background.paper',
                        borderRadius: 1,
                        px: 1.5,
                        py: 1,
                        border: '1px solid',
                        borderColor: 'divider'
                    }}
                >
                    <Typography variant="body2" color="text.secondary">
                        {inheritedFromLabel}: {inheritValue ?? '—'}
                    </Typography>
                </Box>
            )}
        </Box>
    );
}
